import { c as _c } from "react/compiler-runtime";
import Add from "@mui/icons-material/Add";
import { Box, IconButton } from "@mui/material";
import React from "react";
type AddArgumentButtonProps = {
  onClick: () => void;
  title: string;
};
export const AddArgumentButton: React.FC<AddArgumentButtonProps> = t0 => {
  const $ = _c(4);
  const {
    onClick,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Add />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick || $[2] !== title) {
    t2 = <Box display="flex" justifyContent="center"><IconButton title={title} onClick={onClick}>{t1}</IconButton></Box>;
    $[1] = onClick;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};